import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SiteLayout from "./components/SiteLayout";
import { LanguageProvider } from "./LanguageContext";
import HomePage from "./pages/HomePage";
import { UiProvider } from "./UiContext";
import "./App.css";

const BlogPage = lazy(() => import("./pages/BlogPage"));
const BlogPostPage = lazy(() => import("./pages/BlogPostPage"));
const LabPage = lazy(() => import("./pages/LabPage"));
const LabDetailPage = lazy(() => import("./pages/LabDetailPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

export default function App() {
	return (
		<LanguageProvider>
			<UiProvider>
				<BrowserRouter>
					<Suspense fallback={null}>
						<Routes>
							<Route element={<SiteLayout />}>
								<Route path="/" element={<HomePage />} />
								<Route path="/blog" element={<BlogPage />} />
								<Route path="/blog/:slug" element={<BlogPostPage />} />
								<Route path="/lab" element={<LabPage />} />
								<Route path="/lab/:id" element={<LabDetailPage />} />
							</Route>
							<Route path="*" element={<NotFoundPage />} />
						</Routes>
					</Suspense>
				</BrowserRouter>
			</UiProvider>
		</LanguageProvider>
	);
}
